import { graphql } from '@graphql/__generated'

export const UPDATE_MEMBERSHIP = graphql(`
  mutation UpdateMembership($data: UpdateMembershipInput!) {
    updateMembership(data: $data) {
      __typename

      ... on MutationOutput {
        success
      }

      ... on APIError {
        error
        code
      }
    }
  }
`)
